import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const AddKitchen = () => {
  const [stocks, setStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [kitchenId, setKitchenId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);

  const subkichenIddd = localStorage.getItem("subkichen_id_viwe");
  if (!subkichenIddd) return;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      fetchDataList(user.kitchen);
    }
  }, []);


  const fetchDataList = (kitchenId) => {
    axios.get(`https://api-ims.indevconsultancy.in/sub-kichange-get.php?kitchen_id=${kitchenId}`)
      .then((res) => {
        if (res.data.status === "success") {
          const formatted = res.data.data.map((item) => ({
            id: item.subkichen_id,
            kitchenName: item.subKitchen_name,
            status: item.status === "1" ? "Active" : "Inactive",
          }));
          setUsers(formatted);
        } else {
          setUsers([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching sub-kitchens:", err);
        setUsers([]);
      });
  };


  // Fetch API data
  useEffect(() => {

    fetchStockData();
  }, [kitchenId]);

  const fetchStockData = async () => {
    const subkichenId = localStorage.getItem("subkichen_id_viwe");
    const KitchenType = localStorage.getItem("KitchenType");
    if (!kitchenId) return;
    if (!KitchenType) return;
    try {
      const res = await axios.get(`https://api-ims.indevconsultancy.in/sub-stoct-list.php?kitchen_id=${kitchenId}&subkichenId=${subkichenId}&KitchenType=${KitchenType}`);
      if (res.data.status === "success") {
        setStocks(res.data.data);
        setFilteredStocks(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching stock list:", err);
    } finally {
      setLoading(false);
    }
  };


  // Auto filter when searchTerm changes
  useEffect(() => {
    if (!searchTerm) {
      setFilteredStocks(stocks);
    } else {
      const search = searchTerm.toLowerCase();
      const filtered = stocks.filter(
        (item) =>
          item.stock_name.toLowerCase().includes(search) ||
          item.quantity.toString().includes(search)
      );
      setFilteredStocks(filtered);
    }
  }, [searchTerm, stocks]);

  // Reset filter
  const handleReset = () => {
    setSearchTerm("");
    setFilteredStocks(stocks);
  };
  const [errors, setErrors] = useState({});
  const [switchData, setSwitchData] = useState({
    kitchen_from: "",
    sub_from: "",
    kitchen_to: '',
    sub_to: "",
    items_id: "",
    stock_name: "",
    quantity_avila: "",
    quantity: "",
    KitchenType: ""
  });


  const openSwitchModal = (item) => {
    console.log("item", item)
    const subkichenId2 = localStorage.getItem("subkichen_id_viwe");
    const KitchenType = localStorage.getItem("KitchenType");
    if (!subkichenId2) return;
    if (!KitchenType) return;

    setSwitchData({
      kitchen_from: item.kitchen_id,
      sub_from: item.subkichen_id,
      items_id: item.items_id,
      stock_name: item.stock_name,
      quantity_avila: item.quantity,
      quantity: "",
      kitchen_to: subkichenId2 ?? '',
      KitchenType: KitchenType ?? '',
      sub_to: ""
    });

    // Show Modal
    const modal = new bootstrap.Modal(document.getElementById("switchModal"));
    modal.show();
  };


  const submitSwitch = async () => {
    let newErrors = {};

    if (!switchData.kitchen_to) newErrors.kitchen_to = true;
    if (!switchData.sub_to) newErrors.sub_to = true;
    if (!switchData.quantity) newErrors.quantity = true;

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    try {
      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/sub-stock-swich-v1.php",
        switchData,
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // 🔥 Correct modal close
      const modalEl = document.getElementById("switchModal");
      const modal = bootstrap.Modal.getInstance(modalEl);
      modal.hide();
      fetchStockData();
      alert(response.data.message);



    } catch (error) {
      console.error("CORS Error: ", error);
      alert("Something went wrong!");
    }

  };
  const [errorsMain, setErrorsMain] = useState({});
  const [switchDataMain, setSwitchDataMain] = useState({
    kitchen_from: "",
    sub_from: "",
    kitchen_to: '',
    kitchenId: "",
    items_id: "",
    stock_name: "",
    quantity_avila: "",
    quantity: "",
    KitchenType: ""
  });
  const openSwitchModalMail = (item) => {
    console.log("item", item)
    const subkichenId2 = localStorage.getItem("subkichen_id_viwe");
    const KitchenType = localStorage.getItem("KitchenType");
    if (!subkichenId2) return;
    if (!KitchenType) return;

    setSwitchDataMain({
      kitchen_from: item.kitchen_id,
      sub_from: item.subkichen_id,
      items_id: item.items_id,
      stock_name: item.stock_name,
      quantity_avila: item.quantity,
      quantity: "",
      kitchen_to: subkichenId2 ?? '',
      KitchenType: KitchenType ?? '',
      kitchenId: kitchenId
    });

    // Show Modal
    const modal = new bootstrap.Modal(document.getElementById("mainswitchModal"));
    modal.show();
  };

  const submitSwitchMain = async () => {
    let newErrors = {};
    if (!switchDataMain.kitchen_to) newErrors.kitchen_to = true;
    if (!switchDataMain.quantity) newErrors.quantity = true;

    setErrorsMain(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    try {
      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/sub-stock-swich-main.php",
        switchDataMain,
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // 🔥 Correct modal close
      const modalEl = document.getElementById("mainswitchModal");
      const modal = bootstrap.Modal.getInstance(modalEl);
      modal.hide();
      fetchStockData();
      alert(response.data.message);



    } catch (error) {
      console.error("CORS Error: ", error);
      alert("Something went wrong!");
    }

  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        {/* Breadcrumb + Title */}
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/mobilehome">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Stock List</span>
          </div>
        </div>

        {/* Stock List Card */}
        <div className="card">
          <div className="card-header border-info">
            <div className="row g-3">
              <div className="col-lg">
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-lg-2">
                <button
                  type="button"
                  className="btn btn-outline-dark w-100"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

          <div className="card-body">
            {/* Table */}
            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Max Quantity</th>
                    <th>Min Quantity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6">Loading...</td>
                    </tr>
                  ) : filteredStocks.length > 0 ? (
                    filteredStocks.map((item, index) => (
                      <tr key={item.substock_id}>
                        <td>{index + 1}</td>
                        <td>{item.stock_name}</td>
                        <td>{item.quantity}</td>
                        <td>{item.max}</td>
                        <td>{item.min}</td>
                        <td>
                          <button className="btn btn-sm btn-primary me-2" onClick={() => openSwitchModal(item)}>Switch Data</button>
                          <button className="btn btn-sm btn-secondary me-2" onClick={() => openSwitchModalMail(item)}>Main Switch Data</button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* Switch Quantity Modal */}
      <div className="modal fade" id="switchModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Switch Item Quantity</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label>Select To Kitchen</label>
                <select
                  className="form-select" disabled
                  value={switchData.kitchen_to}
                  onChange={(e) =>
                    setSwitchData({ ...switchData, kitchen_to: e.target.value })
                  }
                >
                  <option value="">Select Kitchen</option>
                  {users.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.kitchenName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={switchData.stock_name}
                  onChange={(e) =>
                    setSwitchData({ ...switchData, stock_name: e.target.value })
                  }
                  disabled
                />
              </div>
              <div className="mb-3">
                <label>Select To Sub Kitchen</label>
                <select
                  className={`form-select ${errors.sub_to ? "is-invalid" : ""}`}
                  value={switchData.sub_to}
                  onChange={(e) =>
                    setSwitchData({ ...switchData, sub_to: e.target.value })
                  }
                >
                  <option value="">Select Sub Kitchen</option>

                  {users
                    .filter((item) => item.id != switchData.kitchen_to)
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.kitchenName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Available Quantity</label>

                <input
                  type="text"
                  className="form-control"
                  value={switchData.quantity_avila}
                  onChange={(e) =>
                    setSwitchData({ ...switchData, quantity_avila: e.target.value })
                  }
                  disabled
                />
              </div>
              <div className="mb-3">
                <label>Switch Quantity</label>
                <input
                  type="number"
                  autoComplete="on"
                  placeholder="Enter Switch Quantity"
                  className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
                  value={switchData.quantity}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setSwitchData({ ...switchData, quantity: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={submitSwitch}
              >
                Switch Now
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Main Switch Quantity Modal */}
      <div className="modal fade" id="mainswitchModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Switch Item Main</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label>Select To Kitchen</label>
                <select
                  className="form-select" disabled
                  value={switchDataMain.kitchen_to}
                  onChange={(e) =>
                    setSwitchDataMain({ ...switchDataMain, kitchen_to: e.target.value })
                  }
                >
                  <option value="">Select Kitchen</option>
                  {users.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.kitchenName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={switchDataMain.stock_name}
                  onChange={(e) =>
                    setSwitchDataMain({ ...switchDataMain, stock_name: e.target.value })
                  }
                  disabled
                />
              </div>

              <div className="mb-3">
                <label>Available Quantity</label>

                <input
                  type="text"
                  className="form-control"
                  value={switchDataMain.quantity_avila}
                  onChange={(e) =>
                    setSwitchDataMain({ ...switchDataMain, quantity_avila: e.target.value })
                  }
                  disabled
                />
              </div>
              <div className="mb-3">
                <label>Switch Quantity</label>
                <input
                  type="number"
                  autoComplete="on"
                  placeholder="Enter Switch Quantity"
                  className={`form-control ${errorsMain.quantity ? "is-invalid" : ""}`}
                  value={switchDataMain.quantity}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setSwitchDataMain({ ...switchDataMain, quantity: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={submitSwitchMain}
              >
                Switch Now
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AddKitchen;
